import { render, staticRenderFns } from "./medicineManagement.vue?vue&type=template&id=70d66765&scoped=true&"
import script from "./medicineManagement.vue?vue&type=script&lang=js&"
export * from "./medicineManagement.vue?vue&type=script&lang=js&"
import style0 from "./medicineManagement.vue?vue&type=style&index=0&id=70d66765&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d66765",
  null
  
)

export default component.exports